<template>
  <v-tooltip right>
    <v-btn
      slot="activator"
      v-on="listeners"
      :color="isFavorite ? 'red lighten-1' : 'grey lighten-1'"
      flat
      icon>
      <v-icon v-if="isFavorite">favorite</v-icon>
      <v-icon v-else>favorite_border</v-icon>
    </v-btn>
    <span>加入最愛</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    isFavorite: {
      required: true
    }
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners
      };
    }
  }
};
</script>
